/** Outlet scroller in App — the only page-level scroll container. */
export const APP_SCROLL_ROOT_SELECTOR = '[data-app-scroll-root]';

/** Reset page scroll without locking overflow (panes may still need the outlet). */
export function resetAppScrollRoot(root: HTMLElement = document.querySelector(APP_SCROLL_ROOT_SELECTOR) as HTMLElement): void {
    if (!root)
        return;
    root.scrollTop = 0;
}
